<template>
  <v-container :class="containerClass" fluid>
    <subscription-package-form
      mode="view"
      :subscription-package="subscriptionPackage.data"
      @cancel="onCancel"
    >
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('subscription-packages.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>View {{ subscriptionPackage.data.code }}</h2>
        </div>
      </template>
    </subscription-package-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import SubscriptionPackageForm from '@components/SubscriptionPackage/Form'
export default {
  components: {
    SubscriptionPackageForm,
  },
  layout: LayoutDashboard,
  props: {
    subscriptionPackage: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('subscription-packages.index')
    },
  },
}
</script>
